import { useEffect, useState } from 'react'
import { Button, Stack, } from '@mui/material'
import { Item } from './snippets'
import { Box, useTheme } from '@mui/system'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import { focusElemnt, getLocalData, } from './helper'
import { useAtom } from 'jotai'
import { divideInNIntegers, withPxWidths } from './mathHelper'
import { exportToExcel } from './hook'
import { CargoRoleRightsAtom } from './jotaiState/commonStateAtoms'
import { xlCol } from './constants'
import useToken from '../helpers/useTokens'
import { makeTable } from '../content/Reports/analysisReport/pdfAutotable'
import { lrDetailPdfFooter } from '../content/AcountingReport/common/AcountingConstants'
import AppsIcon from '@mui/icons-material/Apps'
import ManageColumns from './ManageColumnsUI'
import { modalAtom } from './jotaiState/globalStateAtoms'
import { callAddFontRobotoBold } from './font/Roboto-bold'
import { callAddFontRobotoMedium } from './font/Roboto-Medium-normal'
import SearchFilter from './SearchFilter'
import MuiltRenderTable from './MuiltRenderTable'

const currentDateTime = moment(new Date()).format('DD-MMM-YYYY HH:mm')

export const MultiTableComponent = (props) => {
    const theme = useTheme()
    const [modal, setModal] = useAtom(modalAtom)
    const { tableHeaderColor } = theme

    const {
        tables = [], // [{ mainHeader, tableData, excelTableData, criteriaHeaders, criteriaData, reportName }]
        reportName = '',
        hideControls = false,
        hideHeader = false,
        isShowPdfPrint = true,
        isShowManageColumn = false,
        manageColumnID,
    } = props
    const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
    const { Table1: RoleRightTable1 = [] } = cargoRoleRights
    const [roleRightsData] = RoleRightTable1
    const { AllowExportExcel = 1, AllowPrintandPdf = 1 } = { ...roleRightsData }
    const { loginData } = useToken()
    const [searchResult, setSearchResult] = useState(true)
    // ---------------- Manage Column (ONLY FIRST TABLE) ----------------
    const [manageColumn, setManageColumn] = useState([])
    const [columns, setColumns] = useState([])
    const [matches, setMatches] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [processedTables, setProcessedTables] = useState([])

    const visibleColumns = columns.length ? columns : tables[0]?.mainHeader
    const setColumn = async () => {
        const savedColumns = await getLocalData(manageColumnID)
        let defaultColumns = savedColumns?.length ? savedColumns : tables[0]?.mainHeader || []
        setManageColumn(defaultColumns)
        setColumns(isShowManageColumn ? defaultColumns.filter((c) => c.isSelected) : defaultColumns)
    }
    useEffect(() => {
        setColumn()
    }, [manageColumnID, tables])
    const getColumns = (tbl, index) => {
        return index === 0 ? (columns.length ? columns : tbl.mainHeader) : tbl.mainHeader
    }

    useEffect(() => {
        if (!tables?.length) {
            setProcessedTables(tables)
            return
        }

        const updatedTables = tables.map((tbl, idx) => {
            const cols = getColumns(tbl, idx)

            if (!tbl.totalSubKey && !tbl.colSpanMarker) {
                return { ...tbl, tableData: tbl.tableData }
            }

            const headerLengths = tbl.totalSubKey
                ? divideInNIntegers(cols.length, tbl.totalSubKey)
                : []
            const pickedHeadersList = []
            let index = 0

            headerLengths.forEach((span) => {
                pickedHeadersList.push(cols[index]?.field)
                index += span
            })

            const markerIndex = tbl.colSpanMarker
                ? cols.findIndex((col) => col.field === tbl.colSpanMarker)
                : -1

            const updatedData = tbl.tableData.map((row) => {
                if (row.dataType === 'subHeader' && row.totalSubKey) {
                    const subKeyValue = Object.keys(row)
                        .filter((key) => !['dataType', 'align', 'colSpan', 'totalSubKey'].includes(key))
                        .map((key) => row[key] || '')

                    const newObj = {}
                    const colspanObj = {}
                    const alignObj = {}

                    pickedHeadersList.forEach((key, index) => {
                        newObj[key] = subKeyValue[index] ?? ''
                        colspanObj[key] = headerLengths[index]
                        alignObj[key] =
                            index === pickedHeadersList.length - 1
                                ? 'right'
                                : index === 0
                                    ? 'left'
                                    : 'center'
                    })

                    return {
                        ...newObj,
                        dataType: row.dataType,
                        align: alignObj,
                        colSpan: colspanObj,
                        totalSubKey: row.totalSubKey,
                    }
                }

                if (row?.dataType === 'total' && row?.colSpan && markerIndex !== -1) {
                    const firstField = Object.keys(row.colSpan)[0]
                    const span = markerIndex + 1

                    return {
                        ...row,
                        colSpan: {
                            ...row.colSpan,
                            [firstField]: span,
                        },
                    }
                }

                return row
            })

            return {
                ...tbl,
                tableData: updatedData,
            }
        })

        setProcessedTables(updatedTables)
    }, [tables, columns])

    const renderedTables = processedTables.length ? processedTables : tables

    const searchTables = renderedTables.map((tbl, idx) => ({
        id: idx, // or tbl.id if exists
        data: tbl.tableData,
        columnDefs: getColumns(tbl, idx),
        totalColDef: tbl.totalColDef || []
    }));
    const prepareExcel = () => {
        const sourceTables = processedTables.length ? processedTables : tables;
        const headersList = [];
        const dataList = [];
        headersList.push([
            { field: 'reportName', header: `Report Name: ${reportName}` },
            { field: 'companyName', header: `Company Name: ${loginData?.strCompanyName || ''}` }
        ]);
        dataList.push([{}]);
        const firstTable = sourceTables[0];
        if (firstTable?.criteriaData?.length) {
            headersList.push(firstTable.criteriaHeaders || []);
            dataList.push(firstTable.criteriaData || []);
        }
        sourceTables.forEach((tbl, idx) => {
            const cols = getColumns(tbl, idx);

            const mainHeaders = cols.map(col => ({
                field: col.field,
                header: col.exportHead?.replace(/\n/g, ' '),
                textAlign: col.align,
                isExcelLink: col.isExcelLink,
                link: col.link
            }));
            headersList.push(mainHeaders);
            dataList.push(tbl.excelTableData?.length ? tbl.excelTableData : tbl.tableData);
        });

        return { headersList, dataList };
    };
    const printClick = (isSave) => {
        const sourceTables = processedTables.length ? processedTables : tables;
        jsPDF.API.events.push(['addFonts', callAddFontRobotoBold]);
        jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium]);

        const orientation = visibleColumns.length > 14 ? 'l' : 'p';
        const format = orientation === 'l' ? [1810, 1280] : [1280, 1810];
        const pdfFontSize = 1;
        let totalPagesExp = '{total_pages_count_string}';

        const doc = new jsPDF({ orientation, format, unit: 'px', compress: true });

        doc.setProperties({
            title: `${reportName}.pdf`,
            subject: `${reportName}`,
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system, Receive',
            creator: 'MTLPL',
        });

        const pageTop = 120;
        const didDrawPage = (data) => {
            // HEADER
            doc.setTextColor(40);
            doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50);
            doc.setFontSize(26).setFont('Roboto', 'bold');
            doc.setTextColor(16, 79, 162);
            doc.text(`Cargo System | ${reportName}`, 90, 80);
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(22).setFont('Roboto', 'bold');
            doc.text(
                `Company Name :${loginData.strCompanyName}`,
                doc.internal.pageSize.width - data.settings.margin.left,
                80,
                'right'
            );
            lrDetailPdfFooter(data, loginData, totalPagesExp);
        };

        let startY = pageTop;

        sourceTables.forEach((tbl, idx) => {
            if (idx === 0 && tbl.criteriaData?.length) {
                const headerColumns = (tbl.criteriaHeaders || []).map((col) => ({
                    header: col.header,
                    dataKey: col.field,
                    xlCol: col.xlCol || xlCol,
                }));

                makeTable(
                    doc,
                    autoTable,
                    headerColumns,
                    tbl.criteriaData || [],
                    pdfFontSize,
                    tbl.reportName || reportName,
                    loginData,
                    'everyPage',
                    didDrawPage,
                    startY,
                    false
                );
                startY = doc.lastAutoTable.finalY + 10;
            }

            // Main tables
            const visibleCols = getColumns(tbl, idx);
            const pdfColumns = withPxWidths(visibleCols, format[0] - 60).map((col) => ({
                header: col.exportHead,
                dataKey: col.field,
                xlCol: col.xlCol,
                width: col.width || 0,
            }));

            // Print table name above main table
            if (tbl.reportName) {
                autoTable(doc, {
                    margin: { left: 30, right: 30, bottom: 0 },
                    startY: doc.lastAutoTable.finalY + 14,
                    theme: 'plain',
                    head: [],
                    body: [[tbl.reportName]],
                    bodyStyles: {
                        minCellHeight: 35,
                        valign: 'middle',
                        font: 'Roboto',
                        fontStyle: 'bold',
                        fontSize: 16,
                        halign: 'left',

                    },
                    didParseCell: function (data) {

                    }
                })
                startY = doc.lastAutoTable.finalY;
            }
            makeTable(
                doc,
                autoTable,
                pdfColumns,
                tbl.tableData,
                pdfFontSize,
                tbl.reportName || reportName,
                loginData,
                hideHeader ? 'never' : 'everyPage',
                didDrawPage,
                startY,
                false,
                true
            );
            startY = doc.lastAutoTable.finalY + 10;
        });

        doc.setFont('Roboto');
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp);
        }
        if (isSave) {
            doc.save(`${reportName} ${currentDateTime}.pdf`);
        }
        setTimeout(() => {
            const pdfUrl = doc.output('bloburl');
            document.getElementById('multiPdf').data = pdfUrl;
            focusElemnt('backBtn');
        }, 1000);
    };



    const onSaveColumns = (items) => {
        setManageColumn(items)
        setColumns(items.filter((col) => col.isSelected))
        localStorage.setItem(manageColumnID, JSON.stringify(items))
    }

    return (
        <>
            <SearchFilter
                tables={searchTables}
                matches={matches}
                setMatches={setMatches}
                currentIndex={currentIndex}
                setCurrentIndex={setCurrentIndex}
            />
            <Stack style={{ margin: '10px' }}>
                <Item
                    className="userReport"
                    style={{ padding: 0, display: hideControls ? 'none' : 'flex' }}
                >
                    <Item
                        className="userReport-heading"
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '10px',
                        }}
                    >
                        Report For: {reportName}

                        {isShowManageColumn && (
                            <Box
                                style={{
                                    height: '32px',
                                    display: 'flex',
                                    padding: '8px 12px',
                                    gap: '6px',
                                }}
                                id="dispatchReportManageColumn"
                                tabIndex={0}
                                onClick={() => setModal('ShowManageColumn')}
                            >
                                <span style={{ display: 'flex', margin: '-3px' }}>
                                    <AppsIcon />
                                </span>
                                <span style={{ fontWeight: 'bold' }}>
                                    MANAGE COLUMNS
                                </span>
                            </Box>
                        )}
                    </Item>

                    <Item className="userReport-buttons" style={{ paddingRight: 0 }}>
                        {searchResult ? (
                            <>
                                <Box>
                                    <Button
                                        variant="outlined"
                                        className="userWisereporttembtn"
                                        disabled={!AllowExportExcel}
                                        onClick={() => {
                                            const { headersList, dataList } = prepareExcel();
                                            exportToExcel({
                                                fileName: `${reportName} ${currentDateTime}.xlsx`,
                                                sheetName: reportName,
                                                headersList,
                                                dataList,
                                            });
                                        }}
                                    >
                                        Export to Excel
                                    </Button>
                                </Box>

                                {isShowPdfPrint && (
                                    <>
                                        <Box>
                                            <Button
                                                variant="outlined"
                                                className="userWisereporttembtn"
                                                onClick={() => {
                                                    setSearchResult(false)
                                                    printClick(true)
                                                }}
                                                disabled={!AllowPrintandPdf}
                                            >
                                                Export to Pdf
                                            </Button>
                                        </Box>

                                        <Box>
                                            <Button
                                                variant="outlined"
                                                className="userWisereporttembtn"
                                                onClick={() => {
                                                    setSearchResult(false)
                                                    printClick(false)
                                                }}
                                                disabled={!AllowPrintandPdf}
                                            >
                                                Print
                                            </Button>
                                        </Box>
                                    </>
                                )}
                            </>
                        ) : (
                            <Box>
                                <Button
                                    id="backBtn"
                                    variant="outlined"
                                    className="userWisereporttembtn"
                                    onClick={() => setSearchResult(true)}
                                >
                                    Back
                                </Button>
                            </Box>
                        )}
                    </Item>
                </Item>
            </Stack>
            <Stack>
                {searchResult ? (
                    renderedTables.map((tbl, idx) => {
                        const cols = getColumns(tbl, idx)
                        return (
                            <MuiltRenderTable
                                key={idx}
                                idx={idx}
                                hideHeader={hideHeader}
                                tableData={tbl.tableData}
                                reportName={tbl.reportName}
                                matches={matches}
                                currentIndex={currentIndex}
                                serialNokey={tbl.serialNokey}
                                tableHeaderColor={tableHeaderColor}
                                cols={cols}
                                isInvoiceRedirect={tbl.isInvoiceRedirect || false}
                            />

                        )
                    })
                ) : (
                    <object id="multiPdf" type="application/pdf" width="100%"
                        height={`${window.innerHeight - 100}px`}
                    />
                )}
            </Stack>

            {modal === 'ShowManageColumn' && (
                <ManageColumns headers={manageColumn} onSave={onSaveColumns} updateModal={setModal} />
            )}
        </>
    )
}
